var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 152,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.856 50.156-18.4-9.289a6.2 6.2 0 0 0-1.45 4.246l3.676 83.844c.295 3.026 15.057 10.895 27.533 16.626-13.033-29.622-12.016-60.2-11.359-95.427Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.856 50.156-18.4-9.289a6.2 6.2 0 0 0-1.45 4.246l3.676 83.844c.295 3.026 15.057 10.895 27.533 16.626-13.033-29.622-12.016-60.2-11.359-95.427Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.234 111.69c-9.199-21.27-12.191-84.671-12.57-85.036L20.856 50.157c-.688 37.408-2.347 63.532 10.82 94.107v-.025c.499 1.161.972 2.31 1.517 3.48a4.226 4.226 0 0 0 5.093 2.213 466.19 466.19 0 0 0 6.814-2.179h.028l2.465-.784c52.515-17.012 71.436-22.849 78.25-24.844a2.9 2.9 0 0 0 2.077-3.049 2.894 2.894 0 0 0-.421-1.253 48.41 48.41 0 0 1-3.265-6.133Z",
    fill: "#EAECEE",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.805 109.651a3.88 3.88 0 0 0 1.885-2.632 3.876 3.876 0 0 0-.777-3.143l-.097-.124c-13.858-17.202-25.881-54.346-25.155-77.107l-88.143 24.99c-2.471 36.157 5.264 69.02 26.167 97.634a4.253 4.253 0 0 0 2.496 1.629 4.253 4.253 0 0 0 2.952-.412c15.322-8.271 80.672-40.835 80.672-40.835Z",
    fill: "#fff",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.661 26.645 20.856 50.157l3.22 32.607 91.357-28.638-.015-.153-2.366-24.05a6.18 6.18 0 0 0-1.391-3.278Z",
    fill: "#EAECEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22.51 59.807 90.8-23.518c.16.228.305.466.436.713l-.694-7.08a6.186 6.186 0 0 0-1.391-3.29L20.856 50.157l3.22 32.608.678-.215-2.245-22.743Z",
    fill: "#D5D9DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.661 26.645 20.856 50.157l3.22 32.607 91.357-28.638-.015-.153-2.366-24.05a6.18 6.18 0 0 0-1.391-3.278v0Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m109.444 24.883-14.73-6.737a6.242 6.242 0 0 0-4.087-.383l-28.972 7.179L5.73 38.8a6.173 6.173 0 0 0-3.269 2.067l18.395 9.29 90.804-23.519a6.23 6.23 0 0 0-2.217-1.756Z",
    fill: "#D5D9DE",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.468 49.182a4.67 4.67 0 0 1-3.247-8.405 16.894 16.894 0 0 0-11.717-30.379A16.966 16.966 0 0 0 60.28 26.39a4.675 4.675 0 1 1-9.338-.435A26.232 26.232 0 1 1 92.79 48.289a4.594 4.594 0 0 1-2.322.893Z",
    fill: "#EAECEE",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.226 13.359a26.366 26.366 0 0 0-23.58 23.97l9.883-2.45A16.894 16.894 0 0 1 54.6 37.805a16.776 16.776 0 0 1-6.746 15.222 4.67 4.67 0 0 0 3.247 8.405 4.616 4.616 0 0 0 2.322-.903 26.233 26.233 0 0 0-18.198-47.17Z",
    fill: "#EAECEE",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.715 88.91a2.083 2.083 0 1 1-4.038 1.036 2.083 2.083 0 1 1 4.038-1.035ZM70.874 97.249a2.083 2.083 0 1 1-4.038 1.035 2.083 2.083 0 1 1 4.038-1.035Z",
    fill: "#EAECEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.295 93.87a1.823 1.823 0 0 1 2.496 1.408 9.098 9.098 0 0 1-5.587 9.623 9.115 9.115 0 0 1-10.733-2.973 1.826 1.826 0 0 1-.285-1.58 1.82 1.82 0 0 1 1.076-1.19l13.033-5.287Z",
    fill: "#ABB2BC",
    stroke: "#ABB2BC",
    strokeWidth: 1.521,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.217 104.936a9.01 9.01 0 0 0 5.293-5.976c-2.49-.4-5.044-.082-7.36.917a13.249 13.249 0 0 0-5.9 4.486 9.03 9.03 0 0 0 7.967.573Z",
    fill: "#D5D9DE",
    stroke: "#ABB2BC",
    strokeWidth: 1.521,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ABB2BC",
    strokeWidth: 1.563,
    strokeLinecap: "round",
    d: "m74.634 90.725 1.459 3.524M80.353 88.358l1.458 3.524"
  })));
};

export default SvgCalendar;